import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import logs from './modules/logs'
import manage from './modules/manage.js'
import statis from './modules/statis.js'
import active from './modules/active.js'
import operation from './modules/operation.js'
import alert from './modules/alert.js'
// import getters from './getters'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    logs,
    manage,
    statis,
    active,
    operation,
    alert
  }
  // getters: getters
  //  plugins: [soda.vuexPlugin]
})